export default {
  // remote request waiting
  isLoginLoading: false,
  isSignUpLoading: false,
  isCreateCaseLoading: false,
  isUpdateCaseLoading: false,
  isAccessCaseLoading: false,
  isGetCaseLoading: false,
  isCreateAccountLoading: false,
  isUpdateAccountFirstNameLoading: false,
  isUpdateAccountLastNameLoading: false,
  isUpdateAccountEmailLoading: false,
  isUpdateAccountPhoneLoading: false,
  isUpdateAccountPasswordLoading: false,
  // isGetCaseByIdLoading: false,
  isLoggedIn: false,
  checkTerm: false,
  error: '',
  loginerror: '',
  resetpwderror: '',
  resetpwdconfirmerror: '',
  signuperror: '',
  confirmsignuperror: '',
  getCasesError: '',
  resetcodeerror: '',
  createcaseerror: '',
  updatebasicerror: '',
  updatecontacterror: '',
  updatemderror: '',
  updatebcherror: '',
  updatefirstnameerror: '',
  updatelastnameerror: '',
  updateemailerror: '',
  updatephoneerror: '',
  updatepwderror: '',
  returnCode: 200,
  // account
  id: 0,
  userDetail: null,
  token: '',
  firstName: '',
  lastName: '',
  email: '',
  emailVerified: false,
  phone: '',
  password: '',
  phoneVerified: false,
  status: 'disable',
  accountRequest: null,
  // cases
  cases: [],
  contacts: [],
  caseDetail: null,
  caseType: 'your child', // backend: child/yourself/your fetus,  add new: fetus not mother /other relative/other not relative
  newCaseRequest: null,
  updateCaseRequest: null,
  updateCaseBasicInfoRequest: null,
  updateCaseContactInfoRequest: null,
  updateCaseMDInfoRequest: null,
  updateCaseBCHInfoRequest: null,
  getCaseByIdRequest: null,
  caseStatus: 0,
  caseId: 0,
  patient: {
    firstName: '',
    lastName: '',
    dob: null,
    mrn: '',
    gender: '',
    story: '',
    dueDate: null,
    addressline1: '',
    addressline2: '',
    city: '',
    state: '',
    country: '',
    zip: '',
    secondaryAddressline1: '',
    secondaryAddressline2: '',
    secondaryCity: '',
    secondaryState: '',
    secondaryCountry: '',
    secondaryZip: '',
    email: '',
    email2: '',
    phone: '',
    phonetype: '',
    phone2: '',
    phone2type: '',
    phone3: '',
    phone3type: '',
    phone4: '',
    phone4type: '',
    languages: [29],
    needInterpreter: 'N',
    pcp: '',
    pcpphone: '',
    pcpemail: '',
    cardiologist: '',
    cardiologistphone: '',
    cardiologistemail: '',
    obgyn: '',
    obgynphone: '',
    obgynemail: '',
    pcpletter: false,
    cardiologistletter: false,
    obgynletter: false
  },
  steponecomplete: false,
  steptwoscreenonecomplete: false,
  steptwoscreentwocomplete: false,
  steptwoscreenthreecomplete: false,
  program: '',
  preferredSurgeon: false,
  preferredSurgeonName: '',
  preferredCardiologist: false,
  preferredCardiologistName: '',
  inpatient: false,
  whyChoose: '',
  hospitalName: '',
  localCountryName: '',
  dataUpdated: false,
  viewSummary: true,
  saveBasicInfo: false,
  saveContactInfo: false,
  saveMDInfo: false,
  saveAdditionalInfo: false,
  activeStep: 0,
  // signup
  showWelcome: true,
  signupActiveStep: 0
};
